/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAtSign: {
  name: 'at-sign';
  data: string;
} = {
  name: 'at-sign',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 1 1 16 0 2 2 0 1 1-4 0V8a1 1 0 0 0-2 0 5 5 0 1 0 1.143 6.8A4 4 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c2.56 0 4.898-.964 6.667-2.547a1 1 0 0 0-1.334-1.49A8 8 0 0 1 4 12Zm10 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z" fill="currentColor"/></svg>`,
};
